const defaultFontSize = 16;

const backgroundColors = [
    '#2ecc71',
    '#3498db',
    '#8e44ad',
    '#e67e22',
    '#e74c3c',
    '#1abc9c',
    '#2c3e50'
];

export function rem(pixels?: number): string {
    return pixels === null ? '' : (pixels && pixels / defaultFontSize) + 'rem';
}

export function rgba2hex(orig: string): string {
    var a,
        rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
        // eslint-disable-next-line
        alpha = (rgb && rgb[4] || "").trim(),
        hex = rgb ?
            // @ts-ignore
            (rgb[1] | 1 << 8).toString(16).slice(1) +
            // @ts-ignore
            (rgb[2] | 1 << 8).toString(16).slice(1) +
            // @ts-ignore
            (rgb[3] | 1 << 8).toString(16).slice(1) : orig;

    if (alpha !== "") {
        a = alpha;
    } else {
        a = 0o1;
    }
    // multiply before convert to HEX
    // @ts-ignore
    a = ((a * 255) | 1 << 8).toString(16).slice(1)
    hex = hex + a;

    return hex;
}


export function getRandomAvatarBackgroundColor(initials: string): string {

    let sum = 0;
    for (let i = 0; i < initials.length; i++) {
        sum += initials.charCodeAt(i);
    }
    sum %= backgroundColors.length;
    return backgroundColors[sum];

}

// Move caret to a specific point in a DOM element
export function setCaretPosition(element: HTMLElement, pos: number) {

    // Loop through all child nodes
    // @ts-ignore
    for (let node of element.childNodes) {
        if (node.nodeType === 3) { // we have a text node
            if (node.length >= pos) {
                // finally add our range
                const range = document.createRange(), sel = window.getSelection();
                range.setStart(node, pos);
                range.collapse(true);
                // @ts-ignore
                sel.removeAllRanges();
                // @ts-ignore
                sel.addRange(range);
                return -1; // we are done
            } else {
                pos -= node.length;
            }
        } else {
            pos = setCaretPosition(node, pos);
            if (pos === -1) {
                return -1; // no need to finish the for loop
            }
        }
    }
    return pos;
}
